export const googleCalendarSchedules = {
  AlekKoenig:
    'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0ubRpejgqt7nCFgJ04zqu-xDcrlGH3tj2ZXSk1vAyoiIGydkyDvO9_2-idjARF69RjW5u2eJAC',
  stub: 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2tOgw4IlygNps4iL8Jv7E00L7VEMt8gzdNK93DvZ0uwWQUXkqkqNVFurUg4z_5gmvZlgHFwS6_', // this is a calendar for engineering@settle.co
}

export const externalLinks = {
  scheduleDemo: googleCalendarSchedules.AlekKoenig,
  applicationsEmail: 'applications@settle.co',
  supportEmail: 'support@settle.co',
  creditSimulator: 'https://capitalcalc.settle.com',
  rolesLearnMore: 'https://intercom.help/settleco/en/articles/6137326-assigning-user-roles',
  googleAuthenticatorIOS: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
  googleAuthenticatorAndroid:
    'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US&pli=1',
  lastPass: 'https://www.lastpass.com/',
  onePassword: 'https://1password.com/',
  settingUpMFA: 'https://help.settle.com/en/articles/6801735-setting-up-multi-factor-authentication-mfa',
  addingAndImportingBills: 'https://intercom.help/settleco/en/articles/6137366-adding-and-importing-invoices',
  howToCreateInvoice: 'https://www.settle.com/blog/how-to-create-an-invoice',
  plaid: {
    root: 'https://plaid.com',
    why: 'https://plaid.com/why-is-plaid-involved',
    apps: 'https://plaid.com/discover-apps',
  },
  finicity: {
    root: 'https://www.finicity.com',
    secure: 'https://www.finicity.com/pay',
    stories: 'https://www.finicity.com/customer-stories',
  },
  shopify: {
    appStoreConnectLink: 'https://apps.shopify.com/settle',
  },
}

export const marketingLinks = {
  marketingRoot: 'https://www.settle.com',
  privacyPolicy: 'https://www.settle.com/privacy-policy',
  workingCapital: 'https://www.settle.com/working-capital',
  purchaseOrders: 'https://www.settle.com/purchase-orders',
  osVideoCard: 'https://www.settle.com/#os-video-card',
  pricing: 'https://www.settle.com/pricing',
  unsupportedIndustries: 'http://www.settle.com/unsupported-industries',
  calculator: 'https://www.settle.com/calculator',
  apAutomation: 'https://www.settle.com/ap-automation',
}

export const looms = {
  purchasingIntroduction: 'https://www.loom.com/embed/110b6e061a7646cb86c57920ab768a5f?t=0',
  billPayProductTour: 'https://www.loom.com/embed/44b4faf5803c44c69d049f594fc9cabd?t=0',
}
